import { LatestWebinarDirective } from './directive';
export { LatestWebinarDirective } from './directive';

angular.module('app').directive('dsLatestWebinar', [LatestWebinarDirective]);
